export const messages = {
  en: {
    printQuestionAnswer: {
      table: {
        name: 'Name',
        type: 'Type',
        options: 'Options',
        selectCount: 'Select Count'
      },
      type: {
        single: 'Single Choice',
        multiple: 'Multiple Choice',
        shortAnswer: 'Short Answer'
      },
      label: {
        total: 'Total',
        submitted: 'Submitted'
      },
      unit: {
        person: 'person(s)'
      }
    }
  },
  zh: {
    printQuestionAnswer: {
      table: {
        name: '名称',
        type: '类型',
        options: '选项',
        selectCount: '选择人数'
      },
      type: {
        single: '单选',
        multiple: '多选',
        shortAnswer: '简答'
      },
      label: {
        total: '总数',
        submitted: '已提交'
      },
      unit: {
        person: '人'
      }
    }
  }
}